import { render, staticRenderFns } from "./AddEducationEntryDialog.vue?vue&type=template&id=2f8c38d4&"
import script from "./AddEducationEntryDialog.vue?vue&type=script&lang=js&"
export * from "./AddEducationEntryDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports